var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',_vm._g(_vm._b({attrs:{"value":_vm.value,"max-width":_vm.maxWidth,"fullscreen":_vm.$vuetify.breakpoint.xsOnly,"persistent":!_vm.terminable}},'v-dialog',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }